<template>
  <Layout>
    <div slot="content">
      <TableView minWidth="900px"
        :keep-page="keepPage"
        :check-actions="edocInsReqCheckAction"
        @action="edocInsReqAction"
        :columns="edocColumns" :list="edocInsReqList" :server-total="edocInsReqTotal" @nextList="selectEdocInsReqList()">
        <template slot="customFilter">
          <Multiselect :options="statusCdList" v-model="listParams.statusCd" track-by="value" label="text" :allow-empty="false" selectedLabel="" deselectLabel="" selectLabel=""
            class="w-125px mw-125px" :placeholder="$t('선택')">
            <template #singleLabel="props">
              <span v-if="props.option.cdClass" :class="`bullet bullet-dot me-2 h-10px w-10px bg-${props.option.cdClass}`"></span><span v-html="props.option.text"></span>
            </template>
            <template #option="props">
              <span v-if="props.option.cdClass" :class="`bullet bullet-dot me-2 h-10px w-10px bg-${props.option.cdClass}`"></span><span v-html="props.option.text"></span>
            </template>
            <template #noResult><span v-text="$t('목록이 없습니다.')"></span></template>
          </Multiselect>
          <Multiselect :options="edocCustList" v-model="listParams.edocCust" track-by="custAbbr" label="custName" :allow-empty="false" selectedLabel="" deselectLabel="" selectLabel=""
            class="min-w-250px mw-250px ms-2" :placeholder="$t('검색어')" :searchable="true">
            <template #noResult><span v-text="$t('목록이 없습니다.')"></span></template>
          </Multiselect>
          <Multiselect :options="edocTmplList" v-model="listParams.edocTmpl" track-by="tmplKey" label="tmplNm" :allow-empty="false" selectedLabel="" deselectLabel="" selectLabel=""
            class="min-w-300px mw-300px ms-2" :placeholder="$t('검색어')" :searchable="true">
            <template #noResult><span v-text="$t('목록이 없습니다.')"></span></template>
          </Multiselect>
        </template>
        <div class="d-flex align-items-center position-relative me-3">
          <b-icon icon="search"></b-icon>
          <input class="form-control form-control-solid w-300px ps-11" :placeholder="$t('e-봉투ID, e-봉투명')" :title="$t('e-봉투ID, e-봉투명')"
            @change="listParams.searchKeyword = $event.target.value">
        </div>
      </TableView>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/components/layout/Layout.vue";
import TableView from "@/components/TableView.vue";
import Multiselect from 'vue-multiselect'

export default {
  components: { Layout, TableView, Multiselect },
  data: () => ({    
    keepPage: false, edocInsReqList: [], edocInsReqTotal: 0,
    statusCdList: [], edocCustList: [], edocTmplList: [],
    listParams: { searchKeyword: '', statusCd: null, edocCust: null, edocTmpl: null },
    edocInsReqCheckAction: [{key: 'EDOC_REQ_ALL', text: '등록요청', variant: 'light-primary'}, {key: 'EDOC_CHK_ALL', text: '확인요청', variant: 'light-primary'}],
    edocColumns: [
      {
        key: 'statusCd', label: '상태', style: { textAlign: 'center' },
        renderer: (item) => {
          return `<b class="badge fs-8 badge-light-${item.statusClass}">${item.statusNm}</b>`;
        }
      },
      {
        key: 'custName', label: '조직',
        renderer: (item) => {
          return `
            <div>${item.custName}</div>
            <div class="fs-8 text-gray-500">${item.custAbbr}</div>
          `;
        }
      },
      {
        key: 'tmplNm', label: '템플릿명',
        renderer: (item) => {
          return `<div>${item.tmplNm}</div><div class="fs-8 text-gray-500">${item.tmplKey}</div>`;
        }
      },
      {
        key: 'title', label: 'e-봉투명',
        renderer: (item) => {
          return `<div>${item.title}</div><div class="fs-8 text-gray-500">${item.envId}</div>`;
        }
      },
      {
        key: 'fileList', label: '파일',
        renderer: (item, scope) => {
          if(scope.$isEmpty(item.fileList)) {
            return `<div class="w-100 text-center">-</div>`;
          } else {
            return `<ul class="edoc_file_list">${item.fileList.map(file => `<li class="fs-8 text-gray-500">${file.attachFileNm}</li>`).join('')}</ul>`;
          }
        }
      },
      { label: 'e-봉투 발신자', renderer: item => `<div>${item.sendUserNm}</div><div class="fs-8 text-gray-500">${item.sendUserId}</div>`, style: { textAlign: 'center' } },
      { key: 'tsaDt', label: '원본검증 시간', type: 'datetime-local', defaultValue: '-', style: { textAlign: 'center' } },
      {
        key: 'reqDt', label: '요청일', style: { textAlign: 'center' },
        renderer: (item, scope) => {
          let content = '';
          if(['UNSENT', '04'].includes(item.statusCd)) {
            content = `<a class="btn btn-xs btn-light-primary" data-u="EDOC_REQ">${scope.$t('등록요청')}</a>`;
          }

          if(item.reqDt) {
            content += `<div>${item.reqDt.f('datetime-local')}</div>`;
          }

          if(item.resCode != '0000') {
            content += `<div class="fs-8 text-danger">${item.resMsg || ''}</div>`;
          }

          return content;
        }
      },
      {
        key: 'chkReqDt', label: '확인일', style: { textAlign: 'center' },
        renderer: (item, scope) => {
          let content = '';
          if(['00', '01', '02'].includes(item.statusCd)) {
            content = `<a class="btn btn-xs btn-light-primary" data-u="EDOC_CHK">${scope.$t('확인요청')}</a>`;
          }

          if(item.chkReqDt) {
            content += `<div>${item.chkReqDt.f('datetime-local')}</div>`;
          }

          if(item.chkProcStatusMsg) {
            content += `<div class="fs-8 text-danger">${item.chkProcStatusMsg || ''}</div>`;
          }
          
          return content;
        }
      },
    ],
  }),
  created() {},
  mounted() {
    this.setFilter();
  },
  beforeDestroy() {},
  computed: {},
  watch: {
    listParams: {
      deep: true,
      handler: 'selectEdocInsReqList'
    }
  },
  methods: {
    /** 필터 기본값이 필터 목록 셋팅 */
    async setFilter() {
      const defStatusCd = {value: '', text: this.$t('전체 상태')};
      const defEdocCust = {custAbbr: '', custName: this.$t('전체 조직')};
      const defEdocTmpl = {tmplKey: '', tmplNm: this.$t('전체 템플릿')};

      this.statusCdList = [defStatusCd].concat(this.$code('EDOC_STATUS_CD'));
      this.edocCustList = [defEdocCust].concat((await this.$api('adm/edoc/view/selectEdocCustList', {})).list);
      this.edocTmplList = [defEdocTmpl].concat((await this.$api('adm/edoc/view/selectEdocTmplList', {})).list);

      this.listParams.statusCd = defStatusCd;
      this.listParams.edocCust = defEdocCust;
      this.listParams.edocTmpl = defEdocTmpl;
    },
    async selectEdocInsReqList(reset) {
      if (reset != undefined) this.edocInsReqList = [];
      const { list, parameter: { total } } = await this.$api('adm/edoc/view/selectEdocInsReqList', { ...this.listParams, firstIndex: this.edocInsReqList.length + 1 });
      this.edocInsReqTotal = total;
      this.edocInsReqList.push(...list);
    },
    async edocInsReqAction({ event, item, key }) {
      const dataKey = event && event.target.dataset ? event.target.dataset.u : '';
      if(key == 'EDOC_REQ_ALL' || dataKey == 'EDOC_REQ') {
        const actionLabel = this.$t('등록요청');
        if (!(await this.$alert(this.$t('해당 항목을 $ 처리하시겠습니까?', [actionLabel]), { okTitle: actionLabel, confirm: true }))) return;

        if(key == 'EDOC_REQ_ALL') {
          this.eDocInsReq(item.map(obj => obj.envId));
        } else if(dataKey == 'EDOC_REQ') {
          this.eDocInsReq([item.envId]);
        }
      } else if(key == 'EDOC_CHK_ALL' || dataKey == 'EDOC_CHK') {
        const actionLabel = this.$t('확인요청');
        if (!(await this.$alert(this.$t('해당 항목을 $ 처리하시겠습니까?', [actionLabel]), { okTitle: actionLabel, confirm: true }))) return;

        if(key == 'EDOC_CHK_ALL') {
          this.eDocInsChk(item.map(obj => obj.envId));
        } else if(dataKey == 'EDOC_CHK') {
          this.eDocInsChk([item.envId]);
        }
      }
    },
    async eDocInsReq(envIds) {
      const res = await this.$api('adm/edoc/view/eDocInsReq', { envIds: envIds });
      if(res.success) {
        let successList = res.data.resultList.filter(result => result.result == true);
        let failList = res.data.resultList.filter(result => result.result == false);
        await this.$alert(`
          <div class="alert_list">
            ${successList.length > 0 ? `
              <div class="text-success text-bolder mb-1">${this.$t('성공')}</div>
              <ul>${successList.map(result => `<li>[${result.mainTitle}] ${result.resultMessage}</li>`).join('')}</ul>
            ` : ``}
            ${failList.length > 0 ? `
              <div class="text-danger text-bolder mb-1">${this.$t('실패')}</div>
              <ul>${failList.map(result => `<li>[${result.mainTitle}] ${result.resultMessage}</li>`).join('')}</ul>
            ` : ``}
          </div>
        `, { size: 'w-500' });

        for(let edocInsReq of res.data.edocInsReqList) {
          this.refreshEdocInsReq(edocInsReq);
        }

        return;
      } else {
        return this.$alert(res.msg);
      }
    },
    async eDocInsChk(envIds) {
      const res = await this.$api('adm/edoc/view/eDocInsChk', { envIds: envIds });
      if(res.success) {
        let successList = res.data.resultList.filter(result => result.result == true);
        let failList = res.data.resultList.filter(result => result.result == false);
        await this.$alert(`
          <div class="alert_list">
            ${successList.length > 0 ? `
              <div class="text-success text-bolder mb-1">${this.$t('성공')}</div>
              <ul>${successList.map(result => `<li>[${result.mainTitle}] ${result.resultMessage}</li>`).join('')}</ul>
            ` : ``}
            ${failList.length > 0 ? `
              <div class="text-danger text-bolder mb-1">${this.$t('실패')}</div>
              <ul>${failList.map(result => `<li>[${result.mainTitle}] ${result.resultMessage}</li>`).join('')}</ul>
            ` : ``}
          </div>
        `, { size: 'w-500' });

        for(let edocInsReq of res.data.edocInsReqList) {
          this.refreshEdocInsReq(edocInsReq);
        }
        return;
      } else {
        return this.$alert(res.msg);
      }
    },
    async refreshEdocInsReq(edocInsReq) {
      this.keepPage = true;
      this.$set(this.edocInsReqList, this.edocInsReqList.findIndex(item => item.envId === edocInsReq.envId), edocInsReq);
      this.$nextTick(()=> { this.keepPage = false; });
    }
  },
}
</script>

<style>
.edoc_file_list {
  list-style: decimal;
  padding: 0;
  margin: 0;
}

.edoc_file_list li {
  padding: 2px;
}
</style>